import { Component, inject, computed } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PrivateToolbarComponent } from '../../shared/ui/private-toolbar/private-toolbar.component';
import { PrivateSidebarComponent } from '../../shared/ui/private-sidebar/private-sidebar.component';
import { SidebarMenuItem } from '../../shared/ui/models/private-sidebar.types';
import { PageHeaderComponent } from '../../shared/ui/page-header/page-header.component';
import { BidDetailsSidebarComponent } from '../../features/shared/components/bid-details-sidebar/bid-details-sidebar.component';
import { BidDetailsSidebarService } from '../../features/shared/services/bid-details-sidebar.service';
import { InvoiceDetailsSidebarComponent } from '../../features/shared/components/invoice-details-sidebar/invoice-details-sidebar.component';
import { InvoiceDetailsSidebarService } from '../../features/shared/services/invoice-details-sidebar.service';
import { LayoutStore } from '../../store/layout.store';
import { ViewContextStore } from '../../store/view-context.store';
import { NewsStore } from '../../store/news.store';
import { CARRIER_MENU } from '../../core/routes/carrier-menu';
import { SHIPPER_MENU } from '../../core/routes/shipper-menu';

@Component({
  selector: 'app-private-layout',
  standalone: true,
  imports: [
    RouterModule,
    TranslateModule,
    PrivateToolbarComponent,
    PrivateSidebarComponent,
    PageHeaderComponent,
    BidDetailsSidebarComponent,
    InvoiceDetailsSidebarComponent,
  ],
  templateUrl: './private-layout.component.html',
  styleUrl: './private-layout.component.scss',
})
export class PrivateLayoutComponent {
  private readonly layoutStore = inject(LayoutStore);
  private readonly viewContext = inject(ViewContextStore);
  private readonly newsStore = inject(NewsStore);
  protected readonly bidSidebarService = inject(BidDetailsSidebarService);
  protected readonly invoiceSidebarService = inject(InvoiceDetailsSidebarService);

  readonly isSidebarExpanded = this.layoutStore.isSidebarExpanded;

  /**
   * Menu driven by activeView — switches instantly when the user
   * toggles between carrier and shipper with no re-render overhead.
   * O item "news" recebe o contador de não lidas (badge da sidebar) aqui,
   * em vez de nos arquivos estáticos de menu, porque só um contexto de injeção
   * consegue ler o NewsStore.
   */
  readonly menuItems = computed<SidebarMenuItem[]>(() => {
    const baseMenu = this.viewContext.activeView() === 'carrier' ? CARRIER_MENU : SHIPPER_MENU;
    return baseMenu.map((item) =>
      item.id === 'news'
        ? { ...item, badgeCount: () => this.newsStore.unreadCount() }
        : item
    );
  });
}
